<script setup lang="ts">
import { GeneralForm } from '@/components/Forms';
import { PersonStores } from '@/store';
import { GeneralProfileInterface } from '@/types';
import { useToast } from 'primevue/usetoast';
import { onMounted } from 'vue';

/**
 * set up the toast
 */
const toast = useToast();

/**
 * All of the state references including the convertion of the
 * profile location state object into a ref.
 */
const profileStore = PersonStores.useUserProfileStore();

const onSave = async (payload: GeneralProfileInterface) => {
  const response = await profileStore.updateGeneralProfileInfo(payload);
  if (response === 200) {
    doToast();
  } else {
    doToast(true);
  }
};

/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'General information has been saved',
    life: 3000,
  });
};

onMounted(async () => {
  await profileStore.getAuthUserProfile();
});
</script>

<template>
  <GeneralForm
    :key="profileStore.id"
    :data="profileStore.general"
    :loading="profileStore.loading"
    :disable-type="true"
    @save="onSave"
  />
</template>
